import { useState } from "react";
import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { toast } from "sonner";
import api, { download, errMsg } from "../lib/api";
import { useApi, PageHeader, Loading, Empty, StatusBadge, Select, TableWrap } from "../components/common";
import { fdate, inr } from "../lib/format";

const STATUSES = ["Draft", "Sent", "Accepted", "Rejected", "Expired"];

export default function Quotations() {
  const [status, setStatus] = useState("");
  const { data, loading, reload } = useApi(`/quotations?status=${status}`);
  const change = async (q, s) => {
    try { await api.post(`/quotations/${q.id}/status?status=${encodeURIComponent(s)}`); toast.success(`${q.code} marked ${s}`); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader title="Quotations" subtitle="Create quotations from a lead or client profile" actions={<Select testid="quote-filter-status" className="w-44" placeholder="All statuses" options={STATUSES} value={status} onChange={setStatus} />} />
      <TableWrap>
        {loading && !data ? <Loading /> : !data?.length ? <Empty text="No quotations" /> : (
          <table className="vmw-table" data-testid="quotations-table">
            <thead><tr><th>Quote</th><th>Date</th><th>Client</th><th>Items</th><th>Total</th><th>Valid Until</th><th>By</th><th>Status</th><th></th></tr></thead>
            <tbody>{data.map((q) => (
              <tr key={q.id} data-testid={`quote-row-${q.id}`}>
                <td className="font-mono text-xs font-semibold">{q.code}</td><td>{fdate(q.date)}</td>
                <td>{q.lead_id ? <Link to={`/leads/${q.lead_id}`} className="hover:text-primary font-medium">{q.client_name}</Link> : q.client_name}<div className="text-xs text-muted-foreground">{q.studio_name}</div></td>
                <td className="text-xs">{q.items.map((i) => i.description).join(", ")}</td><td className="font-num font-semibold">{inr(q.total)}</td>
                <td>{fdate(q.valid_until)}</td><td className="text-xs">{q.created_by_name}</td>
                <td><select data-testid={`quote-status-${q.id}`} className="text-xs border rounded px-1 py-0.5" value={q.status} onChange={(e) => change(q, e.target.value)}>{STATUSES.map((s) => <option key={s}>{s}</option>)}</select></td>
                <td><button onClick={() => download(`/quotations/${q.id}/pdf`, `${q.code}.pdf`)} data-testid={`quote-download-${q.id}`}><Download className="h-4 w-4 text-slate-500 hover:text-primary" /></button></td>
              </tr>))}</tbody>
          </table>)}
      </TableWrap>
    </div>
  );
}
